import React from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import Button from 'shared/components/button/Button';
import {
  validateRecoverEmailCode,
  resetClientPassword
} from '../../ducks/actionsAuthActions';
import InvalidAction from '../InvalidAction/InvalidAction';
import './RecoverEmail.scss';

class RecoverEmail extends React.Component {
  componentDidMount() {
    this.props.validateRecoverEmailCode(this.props.code);
  }

  resetPassword = () => {
    let { resetClientPassword, email } = this.props;
    email && resetClientPassword(email);
  }

  render() {
    let {
      invalidRevertEmailCode,
      invalidRevertEmailCodeError,
      loading,
      fromEmail,
      email,
      emailSent
    } = this.props;

    if (loading) {
      return (<Loader/>);
    }

    if (invalidRevertEmailCode) {
      return (
        <InvalidAction
          title="Something Went Wrong!"
          description={invalidRevertEmailCodeError}
        />
      );
    }

    return (
      <div className="activation-page">
        <div className="activation-content">
          <div className="form-content">
            <h3>Successfully Reverted to restored Email</h3>
            <p>Your sign-in email for Hybrid Fit is successfully reverted from {fromEmail} to {email} </p>
            { emailSent ? (
                <>
                  <p className="verify-hint">
                    We sent a reset password link to {email}. Tap the
                    link in your email to reset your password.
                  </p>
                  <div className="resend-hint">
                    <p>
                      Didn’t recieve the email?{' '}
                      <Button
                        type="submit"
                        color="link"
                        customClasses="resend-btn"
                        label='Resend'
                        onClick={this.resetPassword}
                      />
                    </p>
                  </div>
                </>
              ) : (
                <div className="resend-hint">
                  <p>
                    <Button
                      type="submit"
                      color="link"
                      customClasses="resend-btn"
                      label='Reset Your Password ?'
                      onClick={this.resetPassword}
                    />
                  </p>
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    invalidRevertEmailCode: state.actionsReducer.invalidRevertEmailCode,
    invalidRevertEmailCodeError: state.actionsReducer.invalidRevertEmailCodeError,
    email: state.actionsReducer.email,
    fromEmail: state.actionsReducer.fromEmail,
    loading: state.actionsReducer.loading,
    emailSent: state. actionsReducer.emailSent
  };
}

function mapDispatchToProps(dispatch) {
  return {
    validateRecoverEmailCode: code => dispatch(validateRecoverEmailCode(code)),
    resetClientPassword: email => dispatch(resetClientPassword(email))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecoverEmail);
